import { useEffect, useState } from "react";
import { Receipt } from "lucide-react";
import { api, formatIDR, formatTime } from "@/lib/api";
import { ProofViewer } from "@/components/ProofViewer";

export function PayoutHistory() {
  const [list, setList] = useState(null);
  const [proof, setProof] = useState(null);
  useEffect(() => { api.get("/talent/payouts").then((r) => setList(r.data)).catch(() => setList([])); }, []);
  if (!list) return null;
  return (
    <div className="mt-4 border-t border-border pt-3" data-testid="talent-payout-history">
      <p className="text-xs text-slate-400 mb-2">Riwayat payout</p>
      {list.length === 0 && <p className="text-xs text-slate-500" data-testid="talent-payout-empty">Belum ada payout.</p>}
      <ul className="space-y-1.5">
        {list.slice(0, 5).map((p) => (
          <li key={p.id} className="flex items-center justify-between gap-2 text-sm" data-testid={`talent-payout-${p.id}`}>
            <span className="min-w-0 text-slate-600"><span className="block truncate">{p.note || "Payout"}</span><span className="text-xs text-slate-400">{formatTime(p.created_at)}</span></span>
            <span className="flex items-center gap-2 shrink-0"><span className="font-medium text-slate-800">{formatIDR(p.amount)}</span>{p.has_proof && <button className="btn-ghost h-7 text-xs px-2" onClick={() => setProof(p)} data-testid={`talent-payout-proof-${p.id}`}><Receipt size={12} strokeWidth={1.5} />Bukti</button>}</span>
          </li>
        ))}
      </ul>
      {proof && <ProofViewer payout={proof} endpoint={`/talent/payouts/${proof.id}/proof`} onClose={() => setProof(null)} />}
    </div>
  );
}
